/** Optional manual override when auto-detect is wrong (VPN, multiple NICs). */
export const CSK_DEV_LAN_ORIGIN =
  process.env.NEXT_PUBLIC_CSK_DEV_LAN_ORIGIN?.replace(/\/$/, "") ?? "";

/** Builds a page URL from a LAN origin and Next.js asPath. */
export function buildCskDevLanUrl(origin: string, asPath: string): string {
  return `${origin.replace(/\/$/, "")}${asPath}`;
}
